import clsx from "clsx";
import styles from "./MaterialTags.module.scss";
import { CourseMaterial } from "../index/coursesLoader";
import { Offer } from "common/api/decimal/methods/compareAndPurchase";
import useMaterialTags from "../../common/courses/useMaterialTags.tsx";
import { useLayoutData } from "../layout/myCoursesLayoutLoader.ts";

export default function MaterialTags({
  format,
  buttonLinks,
  className,
}: {
  format: CourseMaterial["materialFormat"] | Offer["variant"];
  buttonLinks?: CourseMaterial["buttonLinks"];
  className?: string;
}) {
  const { config } = useLayoutData();

  const tags = useMaterialTags({
    format,
    buttonLinks,
    labels: config.assets.labels,
  });

  if (tags.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="material-type-tag"
      className={clsx(styles.container, className)}
    >
      {tags.map((tag) => (
        <div
          className={clsx(
            "vst-tag",
            "vst-tag-size-small",
            "vst-tag-option-ellipsis"
          )}
          key={tag}
        >
          {tag}
        </div>
      ))}
    </div>
  );
}
